export const messages = Object.freeze({
    lfs_bucket_not_owned: 'The large file storage bucket is not owned.',
    pv_not_found: 'The storage volume operation could not be completed because required storage resources were not found. Please contact support.',
    tenant_afs_not_found:
        'The integration file storage operation could not be completed because required storage resources were not found. Please contact support.',
    tenant_ceph_credential_failed: 'Storage credentials could not be created. Please contact support.',
    tenant_cluster_disabled: 'Tenant cluster is not enabled.',
    tenant_cluster_not_bootstrapped: 'The tenant cluster is not bootstrapped.',
    tenant_cluster_rpid_mismatch: 'Tenant cluster resource pool mismatch.',
    tenant_s3_credential_not_ready: 'The tenant S3 credential is not ready.',
    tenant_s3_credential_scope_mismatch: 'Tenant S3 credential scope mismatch.'
})

export const dialogs = Object.freeze({})
